import { render, staticRenderFns } from "./resetStudentPwd.vue?vue&type=template&id=38603be5&scoped=true&"
import script from "./resetStudentPwd.js?vue&type=script&lang=js&"
export * from "./resetStudentPwd.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38603be5",
  null
  
)

export default component.exports